import ztComponent from './ztAvatar.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
